<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">活动分类</div>
            <el-select v-model="activityTypeCode" @change="typeChange" filterable clearable placeholder="请选择活动分类" style="width: 100%">
              <el-option
                  v-for="item in activityTypeList"
                  :key="item.activityTypeCode"
                  :label="item.name"
                  :value="item.activityTypeCode">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">活动项目</div>
            <el-select v-model="activityItemCode"  @change="itemChange" filterable clearable placeholder="请选择活动项目" style="width: 100%">
              <el-option
                  v-for="item in activityItemList"
                  :key="item.activityItemCode"
                  :label="item.name"
                  :value="item.activityItemCode">
              </el-option>
            </el-select>
          </el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">活动内容</div>
            <el-select v-model="activityContentCode" filterable clearable placeholder="请选择活动内容" style="width: 100%">
              <el-option
                  v-for="item in activityContentList"
                  :key="item.activityContentCode"
                  :label="item.name"
                  :value="item.activityContentCode">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">志愿队伍</div>
            <el-select v-model="volunteerTeamCode" filterable clearable placeholder="请选择志愿队伍" style="width: 100%">
              <el-option
                  v-for="item in volunteerTeamList"
                  :key="item.volunteerTeamCode"
                  :label="item.name"
                  :value="item.volunteerTeamCode">
              </el-option>
            </el-select>
          </el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">实践站点</div>
            <el-select v-model="practiceSiteCode" filterable clearable placeholder="请选择实践站点" style="width: 100%">
              <el-option
                  v-for="item in practiceSiteList"
                  :key="item.practiceSiteCode"
                  :label="item.name"
                  :value="item.practiceSiteCode">
              </el-option>
            </el-select>
          </el-col>
        </el-row>


      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Add',
  props: [],
  data() {
    return {

      loading: false,

      activityTypeList:[],
      activityTypeCode:'',

      activityItemList:[],
      activityItemCode:'',

      activityContentList:[],
      activityContentCode:'',

      volunteerTeamList:[],
      volunteerTeamCode:'',

      practiceSiteList:[],
      practiceSiteCode:'',


    }
  },
  methods: {

    init(){

      this.volunteerTeamCode = '';
      this.practiceSiteCode = '';

      this.getTypeList();

      this.getVolunteerTeamList();
      this.getPracticeSiteList();

    },
    closeSelf() {
      this.loading= false
      this.$emit("closeAdd");
    },

    confirm(){

      if(this.activityContentCode === ''){
        this.$message("请选择活动内容");
        return;
      }
      if(this.volunteerTeamCode === ''){
        this.$message("请选择志愿队伍");
        return;
      }
      if(this.practiceSiteCode === ''){
        this.$message("请选择实践站点");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityOrder/AddByCommandCenter',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          activityContentCode:this.activityContentCode,
          volunteerTeamCode:this.volunteerTeamCode,
          practiceSiteCode:this.practiceSiteCode,
        }

      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },



    typeChange(val){
      this.activityTypeCode = val;
      this.activityItemCode = '';
      this.activityContentCode = '';
      this.getItemList();
    },
    itemChange(val){
      this.activityItemCode = val;
      this.activityContentCode = '';
      this.getContentList();
    },


    getTypeList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityType/List',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.activityTypeList = response.data.data.list;

          if(this.activityTypeList.length>0){
            this.activityTypeCode = this.activityTypeList[0].activityTypeCode;
            this.getItemList();
          }

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },
    getItemList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityItem/List',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          activityTypeCode:this.activityTypeCode,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.activityItemList = response.data.data.list;
          if(this.activityItemList.length>0){
            this.activityItemCode = this.activityItemList[0].activityItemCode;
            this.getContentList();
          }
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },
    getContentList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityContent/List',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          activityItemCode:this.activityItemCode,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.activityContentList = response.data.data.list;
          if(this.activityContentList.length>0){
            this.activityContentCode = this.activityContentList[0].activityContentCode;
          }
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


    getVolunteerTeamList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'VolunteerTeam/List',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          applyStatus:2,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.volunteerTeamList = response.data.data.list;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },
    getPracticeSiteList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'PracticeSite/List',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          applyStatus:2,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.practiceSiteList = response.data.data.list;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


  }
}
</script>


